import { render, staticRenderFns } from "./fastvaluedeal-reviewer.vue?vue&type=template&id=03404a47&scoped=true&"
import script from "./fastvaluedeal-reviewer.vue?vue&type=script&lang=js&"
export * from "./fastvaluedeal-reviewer.vue?vue&type=script&lang=js&"
import style0 from "./fastvaluedeal-reviewer.vue?vue&type=style&index=0&id=03404a47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03404a47",
  null
  
)

export default component.exports